<template>
  <div>
    <v-dialog v-bind:value="value"
              v-on:input="$emit('input', $event)"
              width="500">
      <v-card>
        <v-card-title class="headline primary--text">
          {{ title }}
        </v-card-title>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-spacer />
          <v-btn color="secondary"
                 text
                 v-on:click="cancel">
            {{ cancelButtonLabel }}
          </v-btn>
          <v-btn text
                 v-bind:color="confirmButtonColor"
                 v-on:click="confirm">
            {{ confirmButtonLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data: () => ({
      resolve: null
    }),
    methods: {
      cancel() {
        this.$emit('input', false)
        this.resolve(false)
      },
      confirm() {
        this.$emit('input', false)
        this.$emit('confirm')
        this.resolve(true)
      },
      async open(resolve) {
        this.resolve = resolve
        this.$emit('input', true)
      }
    },
    name: 'ConfirmDialog',
    props: {
      cancelButtonLabel: String,
      confirmButtonColor: {
        default: 'accent',
        type: String
      },
      confirmButtonLabel: String,
      message: String,
      title: String,
      value: Boolean
    }
  }
</script>